import { getSingleProfile } from "deso-protocol";

type ValidateUsernameOptions = {
  currentUsername?: string | null;
};

export const isSameUsernameInsensitive = (
  username: string,
  currentUsername?: string | null,
) =>
  !!currentUsername && username.toLowerCase() === currentUsername.toLowerCase();

export const validateUsername = async (
  username: string,
  { currentUsername }: ValidateUsernameOptions = {},
) => {
  if (isSameUsernameInsensitive(username, currentUsername)) {
    return true;
  }

  try {
    await getSingleProfile({ Username: username });

    return false;
  } catch {
    return true;
  }
};
